import IconTwitter from './IconTwitter';

export default IconTwitter;